import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicLanguagesGrammar = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Languages and Grammar in TOC"
      videos={[
        "https://www.youtube.com/embed/5Jd54dxQ1_Q",
        "https://www.youtube.com/embed/p0GkZytuzpc",
      ]}

      takeaways={[
        { text: "Learn how to define grammar for a language." },
      ]}
      questions={[
        {text:"Define the grammar for a given language."},
        {text:"Explain the components of a formal grammar."},
        {text:"How is grammar used to generate strings in a language?"},
      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicLanguagesGrammar };